import moment, { Moment } from 'moment';
import { Value } from '@philips-internal/oswald-ui-core';
import { ItemPepType, RulesItemConfiguration } from '../../constants/utils-pep';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../constants/endpoints';
import { YesNoType } from '../../utils/enum-utils';
import { HealthHistoryListContext } from './service/health-history-list-service';

export default class HealthHistoryCommons {

  public static getOnlyYear(date: Value | Moment): number {
    return (date && moment.isMoment(date)) ? date.year() : date as number;
  }

  public static setVisibleFields(fields: any[], value: boolean): void {
    fields.forEach(field => this.setVisibleField(field,value));
  }

  public static setVisibleField(field: any, value: boolean): void {
    field.setVisible(value);
  }

  public static setEnableField(field: any, value: boolean): void {
    field.setEnabled(value);
  }

  public static setEnableFields(fields: any[], value: boolean): void {
    fields.forEach(field => field.setEnabled(value));
  }

  public static setEmptyAndVisible(field: any, value: boolean): void {
    if (!value) {
      this.setEmptyField(field);
    }
    this.setEnableField(field, value);
  }

  public static setEmptyField(field: any): void {
    field.setValue('');
  }

  public static checkHealthHisotryEditPermission(): Promise<void> {
    const itemType = ItemPepType.HEALTH_HISTORY;
    return HttpService.get(Endpoint.PEP_CAN_EDIT_ITEM, { itemType })
      .then(response => {
        const configuration = response.body as RulesItemConfiguration;
        const isAllowEdit = configuration?.allowEditing === YesNoType.YES;
        HealthHistoryListContext.isAllowEdit = isAllowEdit;
      })
  }

}
